var _path, _path2, _g, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgFj = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2e52b2",
  d: "M0 85.334h512v341.337H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M256 85.334v22.617l-46.069 30.709H256v64h-46.069L256 233.38v22.617h-22.628L160 207.078v48.919H96v-48.919l-73.372 48.919H0V233.38l46.069-30.72H0v-64h46.069L0 107.951V85.334h22.628L96 134.241V85.334h64v48.907l73.372-48.907z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#d80027"
}, /*#__PURE__*/React.createElement("path", {
  d: "M144 85.329h-32v69.334H0v32h112v69.334h32v-69.334h112v-32H144z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 85.329v15.083l57.377 38.251H80zm256 0v15.083l-57.377 38.251H176z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 85.329v15.083l57.377 38.251H80zm256 0v15.083l-57.377 38.251H176zM0 255.997v-15.082l57.377-38.252H80zm256 0v-15.082l-57.377-38.252H176z"
}))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M332.058 207.765v59.362c0 39.76 51.942 51.942 51.942 51.942s51.942-12.182 51.942-51.942v-59.362L384 192.924l-51.942 14.841z",
  fill: "#f3f3f3"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M435.942 211.475v-22.261H332.059v22.261h44.521v44.523h-44.521v14.84h44.521v49.664c4.479 1.586 7.421 2.277 7.421 2.277s2.942-.691 7.42-2.276v-49.665h44.523v-14.84H391.42v-44.523h44.522z",
  fill: "#d80027"
})));

export default SvgFj;